import { useRoute } from 'vue-router';
import { injectService } from '@patsnap/tahiti-core';
import { RavenService } from '@telecom/shared/services/raven-service/raven-service';
import { removeHistoryQueries } from '@telecom/shared/utils/html';
import { TRACK_EVENT_TYPE } from '@/constants';

const TARGET_FROM = 'from_ip_search_welcome_email';

function getRavenService(ravenService?: Pick<RavenService, 'track'>) {
    return ravenService ?? injectService<RavenService>(RavenService);
}

/**
 * 消费 IP Search 欢迎邮件入口参数并上报按钮来源埋点。
 */
export function useIpSearchEmailTracking(options: {
    ravenService?: Pick<RavenService, 'track'>;
    removeQueries?: (queryKeys: string[]) => void;
} = {}) {
    const route = useRoute();
    const ravenService = getRavenService(options.ravenService);
    const removeQueries = options.removeQueries ?? removeHistoryQueries;
    const fromButton = route.query.from_button;

    if (route.query.from !== TARGET_FROM || typeof fromButton !== 'string' || !fromButton) {
        return;
    }

    void ravenService.track(fromButton, {
        eventType: TRACK_EVENT_TYPE.SS_PLG_PATSNAP_WEBSITE_CLICK,
    });
    removeQueries(['from_button']);
}
